module.exports = __webpack_public_path__ + "img/vertical-logo.f45268a8.png";